// Only the configured Secure origin can receive the account-settings handoff.
export function accountSecurityURL(base) {
  if (!base) return undefined;
  try {
    const url = new URL(base);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return undefined;
    return `${url.origin}/settings/security`;
  } catch (_) { return undefined; }
}



// WEBPACK FOOTER //
// ./src/utils/accountSecurityURL.js